
import React, { Component } from 'react';
import moment        from 'moment';
import Lightbox      from 'react-images';
import RenderAvatarP from './render_avatar_p'

class HudTimeLine extends Component {
   
    constructor(props) {
      super(props);
      this.state = {lightboxIsOpen : false}
    }

    closeLightbox(){
      this.setState({lightboxIsOpen:false})
    }
    
    openImg(){
      this.setState({lightboxIsOpen:true})
    }
    
    render() {
       
      const renderTipoMidia = (this.props.tipo === 2 ? <a href={void(0)} className="ligthBoxPost" onClick={this.openImg.bind(this)}>
        {this.props.postMidia}
        {this.props.midia? <Lightbox
         images  = {[{ src: this.props.midia }]}
         isOpen  = {this.state.lightboxIsOpen}
         onClose = {this.closeLightbox.bind(this)}  /> : ""}
        
      </a>: this.props.postMidia );
       
        return (

          <div className="communication-message">
                <div className="author author-with-link author-with-line author-with-line-marker">
                    <div className="author-name">
                      {this.props.nome}
                    </div>
                    <div className="author-avatar">
                    <RenderAvatarP Foto={this.props.foto}/>
                    
                    </div>
                </div>
                <div className="communication-message-content communication-container-box">
                    <div className="communication-container-box-left">
                        <div className="communication-container-box-info"></div>
                      {this.props.btAcao}
                        <p>{this.props.postConteudo}</p>
                        {renderTipoMidia}
                        <div className="communication-container-box-actions">
                            <div className="communication-container-box-tools">
                            {this.props.btLike}    {this.props.btComentario}  
                            </div>
                        </div>
                    </div>
                    <div className="communication-container-box-offright">
                        <div className="communication-container-box-offright-item communication-container-box-offright-item-20"></div>
                        <div className="communication-container-box-offright-item communication-container-box-offright-item-70"></div>
                        <div className="communication-container-box-offright-item communication-container-box-offright-item-40"></div>
                        <div className="communication-container-box-offright-item communication-container-box-offright-item-20">
                        {moment(this.props.dataCriado).format("DD/MM/YYYY")}
                        </div>
                    </div>
                </div>
            </div>


               
              );
    }
}

export default HudTimeLine;



// WEBPACK FOOTER //
// ./src/container/renderHudTimeLine.js